module.exports = __webpack_public_path__ + "media/images/header-logo-e33a8228ad681a6c0a07e43b453d2c85.svg";